class PlayerController {
  constructor($sce, $stateParams, $rootScope, $timeout, $state, $interval, $scope, laboxSSapi) {
    this.name = 'player';
    this.$stateParams = $stateParams;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.timer = 0;
    this.$state = $state;
    this.$interval = $interval;
    this.$scope = $scope;
    this.scrubSpeed = 0;

    this.source = $sce.trustAsResourceUrl(this.$stateParams.url);
    var datex="hvjvkjkkj";
    laboxSSapi.logData(datex);
    // this.title = this.$rootScope.title;
    // var player1;
    // var sskyreload;

    this.reloadPlayer();
    // this.video = document.getElementById('video');
    // this.controls = document.getElementById('controls-animation');
    // this.btn = document.getElementById('player-play-pause-button');
    // this.totalTime = document.getElementById('totalTime');
    // this.currTime = document.getElementById('currTime');
    // this.progressBar = document.getElementById('progress-bar');
    // this.progressBarImg = document.getElementById('progress-bar-img');
    // $scope.ffImage = "assets/video_player/Play_button.png";

    // this.timer = this.$timeout(() => {
    //   this.controls.className = 'hide-animation';
    // },5000);

    // this.$onInit = function () {
    //   // progress = setInterval(function(){ this.timeRepeat() }, 200);
    //   this.progressinit = this.$interval(() => {
    //     this.timeRepeat();
    //   }, 200);
    // }

    // this.video.onended = () => {
    //   console.log('!! player on ended');
    //   window.removeEventListener('keydown', this.keydown);
    //   this.$interval.cancel(this.progressinit);
    //   this.$interval.cancel(this.progress);
    //   this.$interval.cancel(this.promise);
    //   this.$rootScope.fromVideoBillPage = true;
    //   this.$rootScope.fromLandingPage = false;
    //   this.$state.go('home.landingpage');
    // }

    // this.video.onplaying = () => {
    //   console.log('!!player on playing');
    //   if (this.fromrewind) {
    //     this.fromrewind = false;
    //     $scope.ffImage = "assets/video_player/Play_button.png";
    //   }
    // }

    this.keyWatch = (event) => {
      window.addEventListener('keydown', this.keydown,false);
    };

    this.keydown = (e)=> {
      if (event.keyCode === 463 || event.keyCode === 80){
        // // console.log('playPause');
        // //stop all intervarls
        // this.$interval.cancel(this.progress);
        // this.$interval.cancel(this.progressinit);
        // this.$interval.cancel(this.promise);

        // this.scrubSpeed = 0;
        // this.controls.className = 'show-animation';
        // $timeout.cancel(this.timer);
        // this.video.playbackRate = 1.0;

        // if(this.action === true) {
        //   this.video.play();
        //   this.action = false;
        // } else {
          this.video.paused ? this.video.play() : this.video.pause();
        // }
        // this.video.paused ? $scope.ffImage = "assets/video_player/Pause_button.png" : $scope.ffImage = "assets/video_player/Play_button.png";
        
        // if(!this.video.paused) {
        //   this.progress = this.$interval(() => {
        //     this.timeRepeat();
        //   }, 200);
        // }
        // this.timer = this.$timeout(() => {
        //   this.controls.className = 'hide-animation';
        // },5000);
      // } else if (event.keyCode === 417 || event.keyCode === 70) {
      //   // console.log('you clicked fast forward!');

      //   this.$interval.cancel(this.progress);
      //   this.$interval.cancel(this.progressinit);
      //   this.$interval.cancel(this.promise);
      //   $timeout.cancel(this.timer);

      //   this.controls.className = "show-animation";
      //   this.action = true;
      //   this.scrubSpeed = this.scrubSpeed < 0 ? 0 : this.scrubSpeed;
      //   if (this.scrubSpeed < 2) {
      //     this.scrubSpeed++;
      //     $scope.ffImage = "assets/video_player/FF"+this.scrubSpeed+".png";
      //   }
      //   this.promise = this.$interval(() => {
      //     this.seekRepeat('forward', this.scrubSpeed);
      //     this.timeRepeat();
      //   }, 100);
      // } else if (event.keyCode === 412 || event.keyCode === 82) {
      //   // console.log('you clicked fast rewind!');

      //   this.$interval.cancel(this.progress);
      //   this.$interval.cancel(this.progressinit);
      //   this.$interval.cancel(this.promise);
      //   $timeout.cancel(this.timer);

      //   this.controls.className = "show-animation";
      //   this.action = true;
      //   this.scrubSpeed = this.scrubSpeed > 0 ? 0 : this.scrubSpeed;
      //   if (this.scrubSpeed > -2) {
      //     this.scrubSpeed--;
      //     $scope.ffImage = "assets/video_player/RR"+Math.abs(this.scrubSpeed)+".png";
      //   }
      //   this.promise = this.$interval(() => {
      //     this.seekRepeat('rewind', this.scrubSpeed);
      //     this.timeRepeat();
      //   }, 100);
      } else if(event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461){
        console.log("you clicked! back");

        // this.$interval.cancel(this.progress);
        // this.$interval.cancel(this.progressinit);
        // this.$interval.cancel(this.promise);

        window.removeEventListener('keydown', this.keydown);
        this.$rootScope.fromVideoBillPage = true;
        this.$rootScope.fromLandingPage = false;
        this.$state.go('home.landingpage');
      }
    }

    // this.$onDestroy = function () {
    //   console.log('!! player on destroy');
    //   window.removeEventListener('keydown', this.keydown);
    //   this.$interval.cancel(this.progress);
    //   this.$interval.cancel(this.progressinit);
    //   this.$interval.cancel(this.promise);
    // };
  }

  // timeRepeat() {
  //   console.log('!! player on time repeat with set');
  //   if(this.video.readyState > 0) {
  //     this.totalMinutes = parseInt(this.video.duration / 60, 10);
  //     this.totalSeconds = parseInt(this.video.duration % 60, 10);
  //     this.totalSecond = ("0" + this.totalSeconds).slice(-2);
  //     this.totalTime.innerHTML = '( ' + this.totalMinutes + ' : ' + this.totalSecond + ' )';
  //     this.totalTimeInSeconds = (this.totalMinutes*60) + this.totalSeconds;

  //     this.currMinutes = parseInt(this.video.currentTime / 60, 10);
  //     this.currSeconds = parseInt(this.video.currentTime % 60, 10);
  //     this.currSecond = ("0" + this.currSeconds).slice(-2);
  //     this.currTime.innerHTML = this.currMinutes + ' : ' + this.currSecond + ' ';
  //     this.currTimeInSeconds = (this.currMinutes*60) + this.currSeconds;

  //     this.percentage = Math.floor((100 / this.video.duration) * this.video.currentTime);
  //     this.progressBar.value = this.percentage;
  //     this.progressBar.style.width = this.percentage + '%';
  //     this.progressBarImg.value = this.percentage;
  //     this.progressBarImg.style.width = this.percentage + '%';
  //   }
  // }
  // seekRepeat(option, scroll) {
  //   console.log('!! player on seek repeat');
  //   const totalTime = this.video.duration;
  //   const currTime = this.video.currentTime;
  //   const frameTime = .2*Math.abs(scroll);
  //   if (option === 'forward') {
  //     if ((currTime + frameTime*Math.abs(scroll)) <= totalTime) {
  //       this.video.playbackRate = 1.0;
  //       this.video.currentTime = this.video.currentTime + frameTime*Math.abs(scroll);
  //     } else {
  //       this.$interval.cancel(this.promise);
  //       this.$interval.cancel(this.progress);
  //       window.removeEventListener('keydown', this.keydown);
  //       this.$rootScope.fromVideoBillPage = true;
  //       this.$rootScope.fromLandingPage = false;
  //       this.$state.go('home.landingpage');
  //     }
  //   } else if (option === 'rewind') {
  //     if ((currTime - frameTime*Math.abs(scroll)) >= 0) {
  //       this.video.playbackRate = 1.0;
  //       this.video.currentTime += -frameTime*Math.abs(scroll);
  //     } else {
  //       this.fromrewind = true;
  //       this.$interval.cancel(this.promise);
  //       this.$interval.cancel(this.progress);
  //       this.video.playbackRate = 1.0;
  //       this.video.currentTime = 0;
  //       this.scrubSpeed = 0;
  //       this.$timeout(() => {
  //         this.controls.className = 'show-animation';
  //         this.video.play();
  //         this.progress = this.$interval(() => {
  //           this.timeRepeat();
  //         }, 200);
  //         this.timer = this.$timeout(() => {
  //           this.controls.className = 'hide-animation';
  //         },5000);
  //       },50);
  //     }
  //   }
  // }
  createPlayer() {
    console.log('create player');
    // var player1 = document.createElement('video');
    // player1.setAttribute('class', 'video');
    // player1.setAttribute('src', this.source);
    // player1.setAttribute('type','video/webm');
    // player1.setAttribute('controls','true');
    // player1.setAttribute('autoplay','true');
    // player1.setAttribute('width','1280');
    // player1.setAttribute('height','650');
    
    var player1 = document.createElement('sundaysky-video');
    player1.setAttribute('id','sskyplayer');
    player1.setAttribute('endpoint-url', 'https://optimum.web.sundaysky.com/create_video_session?id=A0N3R_akOtCtQohonnlU8zs8Xv3Yniwp&amp;statement=6&amp;archetype=0&amp;pon=0&amp;poff=0&amp;theme=2&amp;lang=en&amp;ref=web');
    player1.setAttribute('analytics-token','optimum');  
    player1.setAttribute('session-parameters', '{}');
    player1.setAttribute('poster', 'https://play.sundaysky.com/resources/invitation.png');
    player1.setAttribute('pre-roll','https://play.sundaysky.com/resources/loading.gif');
    player1.setAttribute('autoplay', 'true');
    document.getElementById('sundayskyDiv').appendChild(player1);
  }

  reloadPlayer() {
    console.log('reload player');
    // var sskyreload = document.getElementById('video');
    var sskyreload = document.getElementById('sundayskyDiv');
    sskyreload.innerHTML = "";
    this.createPlayer();
    // sskyreload.appendChild(this.player1); 
  }
}
    
PlayerController.$inject = [
  '$sce',
  '$stateParams',
  '$rootScope',
  '$timeout',
  '$state',
  '$interval',
  '$scope',
  'laboxSSapi'
];

export default PlayerController;


// WEBPACK FOOTER //
// ./client/app/components/player/player.controller.js